import { createFileRoute } from '@tanstack/react-router'
import { Users } from '@/features/users'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/users/')({
  beforeLoad: requireAdmin,
  component: Users,
})
